import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { NacinOtpreme } from './nacin-otpreme';

@Component({
  selector: 'yt-nacin-otpreme',
  templateUrl: './nacin-otpreme.component.html'
})
export class NacinOtpremeComponent
 extends BaseModalContainer<NacinOtpreme> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<NacinOtpreme>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
